document.addEventListener('DOMContentLoaded', function() {

  // *** Scrollable tabs when tab container smaller than the current window width
  const tabsContainer = document.querySelector('.tab-container');
  const tabsWrap = document.querySelector('.tabs-wrap');

  let isDragging = false;
  let initialX;
  let initialScrollLeft;

  function updateClass(element, className, condition) {
    const shouldAddClass = condition();
    if (shouldAddClass && !element.classList.contains(className)) {
      element.classList.add(className);
      // console.log(className, 'added');
    } else if (!shouldAddClass && element.classList.contains(className)) {
      element.classList.remove(className);
      // console.log(className, 'removed');
    }
  }

  function checkWrapUnderflow() {
    return tabsWrap.scrollWidth <= tabsContainer.clientWidth;
  }

  function handleResize() {
    updateClass(tabsWrap, 'unscrollable', checkWrapUnderflow);
  }

  window.addEventListener('resize', handleResize);

  
  handleResize(); // Initial class update based on the current condition

  tabsWrap.addEventListener('mousedown', (event) => {
    if (!checkWrapUnderflow()) { // Only activate if content overflows
      isDragging = true;
      initialX = event.clientX;
      initialScrollLeft = tabsWrap.scrollLeft;
      event.preventDefault();
      updateClass(tabsWrap, 'dragging', () => isDragging);
    }
  });

  tabsWrap.addEventListener('mousemove', (event) => {
    if (isDragging) {
      event.preventDefault();
      const deltaX = event.clientX - initialX;
      tabsWrap.scrollLeft = initialScrollLeft - deltaX;
    }
  });

  tabsWrap.addEventListener('pointerup', (event) => {
    isDragging = false;
    event.preventDefault();
    updateClass(tabsWrap, 'dragging', () => isDragging); // Update on drag release
  });


  // *** Show appropriate content on Tab selection
  const questionContainer = document.querySelector('.question-container');
  
  if (tabsWrap && questionContainer) {
    const tabs = tabsWrap.querySelectorAll('.tab');
    const questionsWraps = questionContainer.querySelectorAll('.question-block');

    const removeActiveClasses = () => {
      tabs.forEach(tab => tab.classList.remove('active'));
      questionsWraps.forEach(question => question.classList.remove('active'));
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const dataId = this.getAttribute('data-id');
        removeActiveClasses();

        this.classList.add('active');
        const activeQuestionTab = questionContainer.querySelector(`.question-block[data-id="${dataId}"]`);
        if (activeQuestionTab) {
            activeQuestionTab.classList.add('active');
        }
      });
    });
  }

});